import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { LineChart } from '@mui/x-charts/LineChart';

const PriceHistoryChart = ({ data, timeRange = '7d' }) => {
  const [chartData, setChartData] = useState({ dates: [], prices: [] });

  useEffect(() => {
    // Update the chart data whenever the input data changes
    if (data && data.length > 0) {
      const dates = data.map(item => new Date(item.timestamp));
      const prices = data.map(item => item.price);
      setChartData({ dates, prices });
    }
  }, [data]);

  // Refresh the component every minute to keep dates current
  useEffect(() => {
    const timer = setInterval(() => {
      if (data && data.length > 0) {
        const dates = data.map(item => new Date(item.timestamp));
        const prices = data.map(item => item.price);
        setChartData({ dates, prices });
      }
    }, 60000); // Update every minute

    return () => clearInterval(timer);
  }, [data]);

  return (
    <Box sx={{ width: '100%', height: '100%', minHeight: 200 }}>
      <LineChart
        series={[
          {
            data: chartData.prices,
            area: true,
            showMark: false,
            color: '#00F5FF',
          },
        ]}
        xAxis={[
          {
            data: chartData.dates,
            scaleType: 'time',
            valueFormatter: (date) => 
              date.toLocaleDateString(undefined, {
                month: 'short',
                day: 'numeric',
              }),
          },
        ]}
        sx={{
          '.MuiLineElement-root': {
            strokeWidth: 2,
          },
          '.MuiAreaElement-root': {
            fillOpacity: 0.1,
          },
          '.MuiChartsAxis-line': {
            stroke: 'rgba(255, 255, 255, 0.2)',
          },
          '.MuiChartsAxis-tick': {
            stroke: 'rgba(255, 255, 255, 0.2)',
          },
          '.MuiChartsAxis-tickLabel': {
            fill: 'rgba(255, 255, 255, 0.7)',
          },
        }}
        tooltip={{
          trigger: 'axis',
        }}
        slotProps={{
          legend: {
            hidden: true,
          },
        }}
      />
    </Box>
  );
};

export default PriceHistoryChart;
